import rp, {
	Service, CodeEditorAdapter, CodeEditorOptions, CodeEditor
} from "@reporting/rp-app-host";
import { HistoryItem } from '@reporting/rp-types/core';
import { Thread } from "@reporting/rp-types/etl";

export class ThreadEditorAdapter extends CodeEditorAdapter<CodeEditor> {

	/** Shared threads live in the master accounting (-1) and only resolve for scope > 0. */
	private scope: number;
	private editable: boolean;

	constructor(
		private etlClient: Service,
		private thread: Thread
	) {
		super();
		this.scope = this.thread.accounting === rp.accountingProvider.a ? 0 : 1;
		this.editable = this.scope === 0;
	}

	getUri(): string {
		// const ext = this.thread?.description?.split('.').pop();
		// if (ext === 'yaml' || ext === 'yml') initYaml();
		return 'file:///person.yaml';
	}

	async getContent(): Promise<string> {
		return await this.etlClient.get<string>(`threads/${this.thread.id_thread}/content`, { scope: this.scope });
	}

	async save(sql: string) {
		await this.etlClient.patch(`threads/${this.thread.id_thread}/content`, sql);
	}

	getHistoryItems(): Promise<HistoryItem[]> {
		return this.etlClient.get<HistoryItem[]>(`threads/${this.thread.id_thread}/history`);
	}

	async getHistoryContent(idz: number): Promise<string> {
		return this.etlClient.get<string>(`threads/${this.thread.id_thread}/history/${idz}`, { scope: this.scope });
	}

	getCurrentItem(): HistoryItem {
		return this.thread;
	}

	getOptions(): CodeEditorOptions {
		//const res = /\.([a-z]*)/i.exec(this.thread.description);
		const ext = this.thread?.description?.split('.').pop();
		return this.createOptions({
			language: ext || 'text/plain',
			readOnly: !this.editable,
			history: this.editable,
			toolbar: {
				save: { enabled: this.editable },
				discard: { enabled: this.editable },
			}
		});
	}

}
